import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type Location = {
  name: string;
  storeNb: number;
};

const initialState = {
  locations: [] as Location[],
  currentLocation: null as Location | null,
};

export const locationSlice = createSlice({
  name: "locationSlice",
  initialState,
  reducers: {
    setLocations(state, action: PayloadAction<Location[]>) {
      state.locations = action.payload;
    },
    resetLocations: state => {
      state.locations = initialState.locations;
    },
    setCurrentLocation(state, action: PayloadAction<Location>) {
      state.currentLocation = action.payload;
    },
  },
});

export const { setLocations, resetLocations, setCurrentLocation } =
  locationSlice.actions;
export default locationSlice.reducer;
